import routes from '../../navigation/Routes'
export const menuList = [
    { 'name': 'Profile', 'route': routes.profile },
    // { 'name': 'License', 'route': routes.subscription },
    // { 'name': 'Order History', 'route': routes.orderHistory },
    { 'name': 'Change Password', 'route': routes.changePassword }
]

export const helpMenuList = [
    { 'name': 'Why School Pivot', 'route': routes.whySchoolPivot },
    { 'name': 'How It Works', 'route': routes.howItWorks },
]